
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 21c-1.95 0-3.604-.68-4.963-2.037C5.68 17.604 5 15.95 5 14c0-1.567.463-2.97 1.388-4.212.925-1.242 2.137-2.08 3.637-2.513a3.484 3.484 0 01-1.438-.712A3.978 3.978 0 017.6 5.325a5.478 5.478 0 01-.525-1.575 5.973 5.973 0 01-.05-1.725 5.02 5.02 0 013.625.925c.5.367.912.808 1.237 1.325.325.517.521 1.1.588 1.75A8.512 8.512 0 0114.3 3.3a.948.948 0 01.7-.275c.283 0 .517.092.7.275a.948.948 0 01.275.7.948.948 0 01-.275.7c-.367.367-.692.77-.975 1.213a4.977 4.977 0 00-.625 1.412c1.467.467 2.65 1.313 3.55 2.538A6.816 6.816 0 0119 14c0 1.95-.68 3.604-2.038 4.963C15.604 20.32 13.95 21 12 21z","fill":"#fff"}})])
          )
        }
      }
    